import { IHighChartsAttributesModel } from './high-charts-attributes.interface';

/**
 * MultiChartModel: Specifically used to help marshall Multi Chart Meta info from the parent component to the multi chart componenet.
 * @param {IHighChartsAttributesModel} highChartsAttributes chart specific data.
 */
export class MultiChartModel {
	constructor(public highChartsAttributes: IHighChartsAttributesModel) {}
}
